import { FormattedMessage } from 'react-intl';

import ExistingLoanPanel from '@components/overviewPanels/existingLoanPanel/ExistingLoanPanel';
import useRetrieveAccountLoanDetails from '@hooks/useRetrieveAccountLoanDetails';

const LoanPanel = () => {
    const {
        data: loanData,
        isLoading,
        isError,
    } = useRetrieveAccountLoanDetails({ expand: true });

    const paidText = (
        <FormattedMessage id="LoanPanel.paid" defaultMessage="Paid" />
    );

    const leftText = (
        <FormattedMessage id="LoanPanel.left" defaultMessage="Left to pay" />
    );

    return (
        <ExistingLoanPanel
            isError={isError}
            title={
                <FormattedMessage
                    id="LoanPanel.title"
                    defaultMessage="Existing loan"
                />
            }
            dataToPlot={[
                {
                    value:
                        loanData?.total_payment_amount -
                        loanData?.outstanding_balance?.total,
                    name: paidText,
                    id: 'paid',
                },
                {
                    value: loanData?.outstanding_balance?.total,
                    name: leftText,
                    id: 'left',
                },
            ]}
            isLoading={isLoading}
            loanId={loanData?.loan_id}
        />
    );
};

export default LoanPanel;
